import ErrorBoundary from '@fuse/utils/ErrorBoundary';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/routes';

/**
 * The main App component.
 */
function App() {
	return (
		<ErrorBoundary>
			<RouterProvider router={router} />
		</ErrorBoundary>
	);
}

export default App;
